$(document).ready(function(){
  
      $(document).find('form.search_coll').on('submit',function(e){
      e.preventDefault();
      
     // console.log($(this).find('.search-template__form-input').val());
      location.href='/search?type=product&q="'+ $(document).find('form.search_coll').find('input[type="text"]').val()+'"&ss=parts';
      $(this).find('.search-template__form-input').val()
      //	$(this).val(''+$(this).val()+'');
    });
  
  
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };
  
  var tech = getUrlParameter('ss');
  if(tech == 'band'){
    $('.itg_band_search').show();
     $('.itg_search.search-template__grid-wrapper').hide();
  
  }
    var tech = getUrlParameter('ss');
  if(tech == 'parts'){
    $('.itg_parts_search').show();
      $('.itg_search.search-template__grid-wrapper').hide();
  
  }

  
  
  
});